import { intRandom } from './_randNum';
import { getRange } from './_getRange';

export function logoAnimation() {
  const container = document.querySelector('.logo-container');

  let ww = window.document.documentElement.clientWidth;

  let logoNum = 4;
  // if(ww <= 767) {
  //   logoNum = 2;
  // }

  const baseWidth = 1440; // 基準となるウィンドウの幅

  const logoMinSpeed = 0.25;
  const logoMaxSpeed = 1.25;
  const logoMinSpeedRatio = 0.6; // 最小サイズの最小調整率
  const logoMaxSpeedRatio = 0.4; // 最大サイズの最小調整率

  const range = 0.8;

  let [adjustedLogoMinSpeed, adjustedLogoMaxSpeed] = getRange(logoMinSpeed, logoMaxSpeed, '', '', ww, baseWidth, logoMinSpeedRatio, logoMaxSpeedRatio);
  let logoObjects = [];

  if(container) {
    const createLogo = (i) => {
      const cW = container.clientWidth;
      const cH = container.clientHeight;

      let rotateName = `logo-rotate`
      let animLeft = `logo-left`
      let animRight = `logo-right`
      
      if (i % 2 === 0) {
        rotateName = `logo-rotate-reverse`
      }

      if (i == 1) {
        animLeft = `logo-left-1`
        animRight = `logo-right-1`
      }

      if (i == 2) {
        animLeft = `logo-left-2`
        animRight = `logo-right-2`
      }

      if (i == 3) {
        animLeft = `logo-left-3`
        animRight = `logo-right-3`
      }
      
      const el = document.createElement('div');
      const _el = document.createElement('div');
      el.classList.add('logo');
      _el.style.animation = `${rotateName} ${intRandom(30000,40000)}ms linear infinite`

      const svgDuration = intRandom(10000,20000)
      
      const svgLeft = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgLeft.classList.add('left');
      svgLeft.style.animation = `${animLeft} ${svgDuration}ms linear infinite`
      svgLeft.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svgLeft.setAttribute('viewBox', '0 0 20.644 92.037');
      const useLeft = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      useLeft.setAttribute('href', '#logo-left');
      svgLeft.appendChild(useLeft)
      _el.appendChild(svgLeft)

      const svgRight = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgRight.classList.add('right');
      svgRight.style.animation = `${animRight} ${svgDuration}ms linear infinite`
      svgRight.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svgRight.setAttribute('viewBox', '0 0 20.644 92.037');
      const useRight = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      useRight.setAttribute('href', '#logo-right');
      svgRight.appendChild(useRight)
      _el.appendChild(svgRight)

      el.appendChild(_el)
      container.appendChild(el);

      // 中心位置を計算
      const centerX = cW / 2;
      const centerY = cH / 2;

      // 中心からの距離（range%の範囲）を計算
      const rangeX = centerX * range;
      const rangeY = centerY * range;

      const left = (Math.random() * 2 - 1) * rangeX + centerX;
      const top = (Math.random() * 2 - 1) * rangeY + centerY;
      el.style.transform = `translate(${left}px, ${top}px)`;

      // スピードは一定にする
      const speed = Math.random() * (adjustedLogoMaxSpeed - adjustedLogoMinSpeed) + adjustedLogoMinSpeed;

      // 角度は水平または垂直を除く
      const angle = Math.random() * 2 * Math.PI;
      const dx = speed * Math.floor(Math.cos(angle));
      const dy = speed * Math.floor(Math.sin(angle));
      const obj = { el, dx, dy };
      logoObjects.push(obj);
    }

    const animateLogos = () => {
      if(logoObjects.length && focus) {
        logoObjects.forEach((obj) => {
          const rect = obj.el.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          if (rect.left + obj.dx < containerRect.left || rect.right + obj.dx > containerRect.right) {
            obj.dx *= -1;
          }
          if (rect.top + obj.dy < containerRect.top || rect.bottom + obj.dy > containerRect.bottom) {
            obj.dy *= -1;
          }
          if (obj.dx === 0) obj.dx = 1;
          if (obj.dy === 0) obj.dy = 1;
          const left = (rect.left - containerRect.left) + obj.dx;
          const top = (rect.top - containerRect.top) + obj.dy;
          obj.el.style.transform = `translate(${left}px, ${top}px)`;
        })
      }
      requestAnimationFrame(animateLogos);
    }

    let focus = true;
    window.addEventListener('focus', () => {
      focus = true;
    })
    window.addEventListener('blur', () => {
      focus = false;
    })

    const init = () => {
      logoObjects.forEach(obj => container.removeChild(obj.el));
      logoObjects = [];
      for (let i = 0; i < logoNum; i++) {
        createLogo(i);
      }
    }

    init();
    animateLogos();

    let lastInnerWidth = window.document.documentElement.clientWidth;
    window.addEventListener('resize', () => {
      if(lastInnerWidth != window.innerWidth) {
        lastInnerWidth = window.document.documentElement.clientWidth;
        ww = lastInnerWidth;
        [adjustedLogoMinSpeed, adjustedLogoMaxSpeed] = getRange(logoMinSpeed, logoMaxSpeed, '', '', ww, baseWidth, logoMinSpeedRatio, logoMaxSpeedRatio);
        init();
      }
    })
  }
}